export default __webpack_public_path__ + "static/media/2021 cutlery side.76314cfe.png";